import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MedjunarodnoPrivrednoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Međunarodno privredno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Međunarodno privredno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Međunarodno privredno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong> Đuro Đurić
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Međunarodno privredno pravo je da pruži osnovna
                znanja o najznačajnijim pravnim institutima relevantnim za
                oblast međunarodnog poslovnog prometa. Analizom ovih instituta
                sa aspekta domaćeg i uporednog prava, prava Evropske unije i
                međunarodnih konvencija, sa posebnim osvrtom na njihovu
                praktičnu primjenu u poslovnoj praksi, kao i odgovarajućih
                slučajeva iz sudske prakse i prakse međunarodnih trgovinskih
                arbitraža, zaokružuje se cjelina pitanja značajnih za poznavanje
                pravnih aspekata međunarodnih poslovnih transakcija.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Po uspješnom okončanju nastavnih aktivnosti i obaveza, očekuje
                se da će stečena znanja u ovoj oblasti omogućiti studentima da
                kritički i stručno analiziraju institute međunarodnog privrednog
                prava, koji su praćeni brojnim drugim pitanjima čije poznavanje
                čini neophodan atribut razumijevanja operacija međunarodnog
                poslovnog prometa. Očekuje se da će da shvate organizacionu
                strukturu poslovnih subjekata, pravne odnose u koje oni stupaju,
                kao i da steknu uvid u pravni kontekst poslovanja kompanija u
                modernim razvijenim tržišnim privredama Evrope, odnosno na
                jedinstvenom tržištu EU.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Uvod u pravo: pravni odnos; subjekti prava; pravna, poslovna i
                deliktna sposobnost fizičkih i pravnih lica; subjektivna prava;
                objekti prava; pravna norma; izvor prava; pravni sistem. Ugovori
                međunarodnog poslovnog prometa: međunarodna prodaja robe –
                pojam, kriterijumi razlikovanja unutrašnje i međunarodne
                prodaje, izvori prava, prava i obaveze ugovornih strana, bitna
                povreda ugovora, raskid ugovora, naknada štete. Obligaciono
                pravo: pojam ugovora; podela ugovora; autonomija volje;
                punovažnost ugovora; zaključenje ugovora; dejstva ugovora;
                prestanak ugovora; prouzrokovanje štete; pojam i vrste štete;
                odgovornost za štetu; naknada štete. Principi evropskog
                ugovornog prava, UNIDROIT Principi međunarodnih trgovinskih
                ugovora. Konvencija UN o ugovorima o međunarodnoj prodaji robe:
                pojam, značaj, oblast primjene, najznačajnija rješenja, njihova
                komparacija sa domaćim zakonodavstvom. Stvarno pravo: pravo
                svojine – pojam, sticanje i prestanak; zaštita prava svojine,
                susvojina i zajednička svojina; založno pravo – pojam, osnovne
                karakteristike, nastanak; vrste založnog prava. Pravni aspekti
                stranih ulaganja: pojam i značaj; relevantni međunarodni
                sporazumi; najznačajnije međunarodne organizacije i institucije;
                Zakon o stranim investicijama. Ugovori o višim oblicima
                privredne saradnje – ugovor o finansijskom lizingu, ugovor o
                franšizingu u međunarodnom prometu. Ostali ugovori međunarodnog
                poslovnog prometa – osnovne karakteristike. Osnovi kompanijskog
                prava: privredni subjekti – preduzeće i preduzetnik; društva
                lica; društva kapitala; ostali oblici; prava, obaveze i
                odgovornost preduzeća u pravnom prometu; povezivanje preduzeća;
                prestanak preduzeća – stečaj i likvidacija. Ugovori o
                trgovinskim uslugama – ugovor o posredovanju, ugovor o
                posredovanju u međunarodnom prometu, ugovor o međunarodnom
                trgovinskom zastupanju, ugovor o komisionu u međunarodnom
                prometu, ugovor o uskladištenju, ugovor o osiguranju robe u
                međunarodnom transportu; ugovori o prevozu. Rješavanje sporova
                putem međunarodnih trgovinskih arbitraža. Međunarodne trgovinske
                arbitraže – pojam i značaj, prednosti arbitražnog rješavanja
                sporova proisteklih iz međunarodne trgovine, vrste arbitraža,
                ugovor o arbitraži, konstituisanje arbitražnog tribunala,
                arbitražni postupak, arbitražna odluka, priznanje i izvršenje
                arbitražnih odluka. Rješavanje sporova iz međunarodnog poslovnog
                prometa: nadležnost sudova, mjerodavno pravo, priznanje i
                prinudno izvršenje stranih presuda.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja i vježbe, seminarski rad, kolokvijumi, završni ispit.
                Interaktivna nastava koja obuhvata uvodno izlaganje od strane
                predavača i učešće studenta; studenti su obavezni da se pripreme
                za nastavu i da učestvuju u diskusiji. Predavanja i vježbe
                praćena su odgovarajućim posebno izrađenim prezentacijama.
                Analiza sudske i arbitražne prakse.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 1V</td>
                    <td>
                      Uvod u pravo: pravni odnos; subjekti prava; pravna,
                      poslovna i deliktna sposobnost fizičkih i pravnih lica;
                      subjektivna prava; objekti prava; pravna norma; izvor
                      prava; pravni sistem
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 1V</td>
                    <td>
                      Stvarno pravo: pravo svojine – pojam, sticanje i
                      prestanak; zaštita prava svojine, susvojina i zajednička
                      svojina; založno pravo – pojam, osnovne karateristike,
                      nastanak; vrste založnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 1V</td>
                    <td>
                      Obligaciono pravo: pojam ugovora; podjela ugovora;
                      autonomija volje; punovažnost ugovora; zaključenje
                      ugovora; dejstva ugovora; prestanak ugovora;
                      prouzrokovanje štete; pojam i vrste štete; odgovornost za
                      štetu; naknada štete
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 1V</td>
                    <td>
                      Principi evropskog ugovornog prava, UNIDROIT Principi
                      međunarodnih trgovinskih ugovora. Konvencija UN o
                      ugovorima o međunarodnoj prodaji robe: pojam, značaj,
                      oblast primjene, najznačajnija rješenja, njihova
                      komparacija sa domaćim zakonodavstvom
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 1V</td>
                    <td>
                      Ugovori međunarodnog poslovnog prometa: međunarodna
                      prodaja robe – pojam, kriterijumi razlikovanja unutrašnje
                      i međunarodne prodaje, izvori prava, prava i obaveze
                      ugovornih strana, bitna povreda ugovora, raskid ugovora,
                      naknada štete;
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>4P + 1V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 1V</td>
                    <td>
                      Ugovori o trgovinskim uslugama – ugovor o posredovanju,
                      ugovor o posredovanju u međunarodnom prometu, ugovor o
                      međunarodnom trgovinskom zastupanju, ugovor o komisionu u
                      međunarodnom prometu, ugovor o uskladištenju, ugovor o
                      osiguranju robe u međunarodnom transportu; ugovori o
                      prevozu
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Ugovori o višim oblicima privredne saradnje – ugovor o
                      finansijskom lizingu, ugovor o franšizingu u međunarodnom
                      prometu
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 1V</td>
                    <td>
                      Ostali ugovori međunarodnog poslovnog prometa – osnovne
                      karakteristike
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 1V</td>
                    <td>
                      Osnovi kompanijskog prava: privredni subjekti – preduzeće
                      i preduzetnik; društva lica; društva kapitala; ostali
                      oblici; prava, obaveze i odgovornost preduzeća u pravnom
                      prometu; povezivanje preduzeća; prestanak preduzeća –
                      stečaj i likvidacija
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 1V</td>
                    <td>
                      Pravni aspekti stranih ulaganja: pojam i značaj;
                      relevantni međunarodni sporazumi; najznačajnije
                      međunarodne organizacije i institucije; Zakon o stranim
                      investicijama
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>4P + 1V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Rješavanje sporova iz međunarodnog poslovnog prometa:
                      nadležnost sudova, mjerodavno pravo, priznanje i prinudno
                      izvršenje stranih presuda;
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 1V</td>
                    <td>
                      Međunarodne trgovinske arbitraže – pojam i značaj,
                      prednosti arbitražnog rješavanja sporova proisteklih iz
                      međunarodne trgovine, vrste arbitraža, ugovor o arbitraži,
                      konstituisanje arbitražnog tribunala, arbitražni postupak,
                      arbitražna odluka, priznanje i izvršenje arbitražnih
                      odluka.
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 1V</td>
                    <td>
                      Rješavanje sporova putem međunarodnih trgovinskih
                      arbitraža
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5č / 3.45h</td>
                            <td>Ukupno: 90h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4č / 3h</td>
                            <td>Nastava + završni ispit: 65h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 10h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MedjunarodnoPrivrednoPravoPM;
